import * as Protocols from '../proto/message';

export {
  Protocols,
  // misspelling
  Protocols as Protocals,
};

export { default as EventEmitter } from 'eventemitter3';

const polyfilledPromise = Promise;
export { polyfilledPromise as Promise };

export {
  /**
   * @name Realtime
   * @memberof module:leancloud-realtime
   * @see Realtime
   */
  default as Realtime,
} from './realtime';

export * from './adapter';

export { debug } from './utils';



// WEBPACK FOOTER //
// ../src/core.js